import { useTheme } from "@emotion/react";
import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CenteredText from "components/CenteredText";
import Page from "components/Page";

import { Link } from "react-router-dom";
import AlzaVolume from "components/AlzaVolume";
import PepperSelfie from "assets/images/pepper_selfie.svg"
import PepperSwag from 'assets/images/pepper_swag.png'
import PepperBalla from 'assets/images/pepper_balla.png'
import PepperEsulta from 'assets/images/pepper_esulta.png'

const modes = {
  'swag': {
    title: 'Osserva Pepper in posa SWAG!',
    img: PepperSwag,
    command: 'SWAG',
    audioFile: "/sounds/swag.mp3",
    repeatSound:true
  },
  'selfie': {
    title: 'Pepper si è messo in posa. Fatti un selfie con lui!',
    img: PepperSelfie,
    command: 'SELFIE',
    audioFile:'/sounds/selfie.mp3',
    repeatSound:true
  },
  'balla': {
    title: 'Osserva Pepper ballare!',
    img: PepperBalla,
    command: 'DANCE',
    audioFile: "/sounds/arcadia.mp3",
    repeatSound:true
  },
  'esulta': {
    title: 'Pepper è contento, guarda come esulta!',
    img: PepperEsulta,
    command: 'ESULTANZA',
    audioFile: '/sounds/game_level_up.mp3',
    repeatSound:true
  }
}
const PepperInteract = ({ mode }) => {
  const theme = useTheme();

  return (
    <Page bg={theme.palette.background.paper} syncNavCommand={modes[mode].command} audioFile={modes[mode].audioFile} repeatSound={modes[mode].repeatSound}>
      <Stack spacing={2} sx={{
        display: 'flex',
        flex: 1
      }}>
        <AlzaVolume />
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          <CenteredText>
            <img src={modes[mode].img} alt={modes[mode].title} />
          </CenteredText>
          <CenteredText>
            <Typography variant="h5" sx={{ paddingInline: '2rem', color: theme.palette.white.main }}>
              {modes[mode].title}
            </Typography>
          </CenteredText>

        </Box>
        <CenteredText sx={{ flex: 0.3 }}>
          <Link to="/gioca_pepper">
            <Typography variant="h6"
              color={theme.palette.white.main}
              sx={{ textDecoration: 'underline' }}>
              Torna a “Gioca con Pepper”
            </Typography>
          </Link>
        </CenteredText>
      </Stack>
    </Page >
  )
}

export default PepperInteract;